import { Version } from '@angular/core';
// import { TreeType } from '../enums/treeTypeEnum';
import { Versions } from './version.interface';
// import { Boiler } from '@usimweb/core/services';

export enum TreeType {
  INPUT_TREE = 'inputTree',
  VERSION_TREE = 'versionTree',
  NO_VERSION_TREE = 'noVersionTree',
}

export enum BoilerPart {
  CONNECTOR = 'connections',
  HEAT_EXCHANGER = 'heatExchangers',
  CYLINDER = 'cylinder',
  AXES = 'axes',
  PATCH = 'patches',
  FLANGE = 'flange',
}

interface Data<VelaCategory, VelaInput, Version, Versions> {
  velaCategory?: VelaCategory;
  velaInput?: VelaInput;
  version?: Version;
  versions?: Versions[];
}

// type mixedData = VelaCategory | VelaInput | Versions | Versions[];

export interface TreeNode {
  name: string;
  type: TreeType;
  data?: Data<VelaCategory, VelaInput, Version, Versions>[];
  // https://www.typescriptlang.org/docs/handbook/2/everyday-types.html#union-types
  // check with Array.isArray()
  // data?: Data<VelaCategory, VelaInput, Version, Versions> | Data<VelaCategory, VelaInput, Version, Versions>[];
  children?: TreeNode[];
  index?: number;
  collapse?: boolean;
  isActive?: boolean;
  part?: BoilerPart;
}

export interface Children {
  name: string;
  value: {};
}

export interface VelaTemplate {
  name: string;
  description: string;
  input_value: VelaInput;
  created_at: string;
  materials: {};
}

// change to VelaInput
// TreeNode => VelaInput & Versions
export interface VelaInput {
  [key: string]: Object[];
}

//  {[key in string]: string};
// genery object which takes a key string
// and returns a string
export interface VelaCategory {
  [key: string]: Object[];
}

export interface VelaInputTest {
  velaInput: VelaRoot;
}

// export interface VelaInput {
//   velaInput: VelaRoot[];
// }

interface VelaRoot {
  tank: Tank;
  insulation: Insulation;
  filling: Filling;
  heatExchangers: HeatExchanger[];
  connections: Connection[];
  simulation: Simulation;
}

interface Simulation {
  nCells: Diameter;
  norm: Material;
  measurementTime: Diameter;
  samplingInterval: Diameter;
  startTemperature: Diameter;
  ambientTemperature: Diameter;
  ambientMaterial: Material;
  convection: Material;
  alphaOutside: Diameter;
  alphaInside: Diameter;
}

interface Connection {
  type: Material;
  height: Diameter;
  innerDiameter: Diameter;
  tubeWallThickness: Diameter;
  flangeOuterDiameter: Diameter;
  flangeThickness: Diameter;
  material: Material;
  insulated: boolean;
  insulationMaterial: Material;
  insulationThickness: Diameter;
}

interface HeatExchanger {
  type: Material;
  power: Diameter;
  startHeight: Diameter;
  endHeight: Diameter;
}

interface Filling {
  material: Material;
}

interface Insulation {
  material: Material;
  thickness: Diameter;
}

interface Tank {
  diameter: Diameter;
  height: Diameter;
  innerWallThickness: Diameter;
  outerWallThickness: Diameter;
  material: Material;
  bottom: Material;
  head: Material;
}

interface Material {
  default: string;
  options: string[];
}

interface Diameter {
  value: number;
  unit: string;
}
